export default "__VITE_ASSET__DmZrIaBx__"